import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorContactList extends InternalStaticAnchor {
	/**
	 * @type {string}
	 * @private
	 */
	_pattern = '/contact/list/all';
}
